export enum StepsEnum {
  ConfirmEan,
  Invoice,
  Transport,
  Delivered,
  None,
}
